import { createRouter } from '@tanstack/react-router'
import type { RouterAuthContext } from './lib/auth/router-context'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

// Declare router context type for type safety across routes
declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}

// Create a new router instance with typed context
export const getRouter = () => {
  const router = createRouter({
    routeTree,
    context: {
      // Initial context - will be hydrated by root route
      session: null,
      isLoading: true,
      isAuthenticated: false,
    } satisfies RouterAuthContext,

    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  })

  return router
}
